import React, {useEffect, useMemo} from 'react'
import {useIntl} from 'react-intl'
import PageLayout from '../../../../components/PageLayout'
import MaintenirEnfantMajeurForm from '../components/MaintenirEnfantMajeurForm'
import {getEnfantMajeurList} from '../../../webservices/affiliation/affiliationSelector'
import {connect} from 'react-redux'
import {compose} from 'redux'
import * as affiliationActions from '../../../webservices/affiliation/affiliationActions'
import {useBreakpoints} from '../../../../components/breakpoints/BreakpointsProvider'
import {getListeDemandes} from "../../../webservices/demandes/demandesSelectors";
import {DemandeBean} from "../../suivieDemande/components/demandeConstants";

const MaintenirEnfantMajeurPage = (
    {
        // @ts-ignore
        individuList,
        // @ts-ignore
        getAffiliation,
        // @ts-ignore
        demandes
    }
) => {
    const intl = useIntl()
    const {isMobile, isTabletPortrait} = useBreakpoints()
    // TODO pas utilisé ?
    const urlParams = new URLSearchParams(window.location.search)
    const selectedNotif = useMemo(() => demandes.find((demande: DemandeBean) => demande.id && demande.id.toString() === urlParams.get('s')), [demandes, urlParams])

    useEffect(() => {
        getAffiliation()
    }, [getAffiliation])

    return (
        <PageLayout title={intl.formatMessage({id: 'maintenirEnfantMajeur.title'})}
                    bodyPadding={isMobile || isTabletPortrait ? '32px 32px 12px 32px' : '32px 32px 0 32px'}>
            <MaintenirEnfantMajeurForm individuList={individuList} demande={selectedNotif}/>
        </PageLayout>
    )
}

// @ts-ignore
const makeMapStateToProps = (state: any) => {
    return ({
        demandes: getListeDemandes(state),
        individuList: getEnfantMajeurList(state),
    })
}

const actions = {
    getAffiliation: affiliationActions.getAffiliation
}

export default compose(
    connect(makeMapStateToProps, actions)
)(MaintenirEnfantMajeurPage)
